import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminNav from '@/components/AdminNav';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Shield, Plus, ExternalLink, ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SafetyAuditDialog from '@/components/SafetyAuditDialog';
import { toast } from 'sonner';

const AdminAudits = ({ user, setUser }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showAuditDialog, setShowAuditDialog] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Back Button */}
        {/* SafetyMind AI Branding */}
        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600 rounded-lg flex items-center justify-center shadow-md">
              <span className="text-white font-bold text-lg">SM</span>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">{t('adminUI.SafetymindAi')}</h2>
              <p className="text-xs text-gray-500 italic">{t('adminUI.SafetyThatThinks')}</p>
            </div>
          </div>
          <Button
            variant="ghost"
            onClick={() => navigate('/admin')}
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('common.back')}
          </Button>
        </div>

        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">{t('audits.title')}</h1>
          <p className="text-gray-600 mt-1">{t('audits.subtitle')}</p>
        </div>

        {/* Info Card */}
        <Card className="mb-6 border-green-200 bg-green-50">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Shield className="w-6 h-6 text-green-600" />
              {t('audits.title')}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-700 mb-4">
              {t('audits.aiHazardDetection')}
            </p>
            <div className="flex gap-3 flex-wrap">
              <Button
                onClick={() => navigate('/company/audits')}
                className="bg-green-600 hover:bg-green-700"
              >
                <ExternalLink className="w-4 h-4 mr-2" />
                {t('common.view')} {t('audits.title')}
              </Button>
              <Button
                onClick={() => setShowAuditDialog(true)}
                variant="outline"
                className="border-green-600 text-green-600 hover:bg-green-50"
                data-testid="admin-new-audit-btn"
              >
                <Plus className="w-4 h-4 mr-2" />
                {t('audits.newAudit')}
              </Button>
            </div>
          </CardContent>
        </Card>
      </main>

      <SafetyAuditDialog
        open={showAuditDialog}
        onOpenChange={setShowAuditDialog}
        user={user}
        onSuccess={() => {
          setShowAuditDialog(false);
          toast.success(t('audits.auditCreated', 'Safety audit created'));
          navigate('/company/audits');
        }}
      />
    </div>
  );
};

export default AdminAudits;
